<template>
  <div class="vx-row mb-6">
    <div class="vx-col w-1/2">
      <span>Territory</span>
      <multiselect
        v-model="selected"
        :options="options"
        placeholder="Type to search"
        track-by="name"
        label="name"
        :max-height="125"
        :allow-empty="false"
      >
        <span slot="noResult">Oops! No data found</span>
        <template slot="singleLabel" slot-scope="props">
          <span class="option__desc">
            <span class="option__title"
              >{{ props.option.code }} {{ props.option.name }}</span
            >
          </span>
        </template>

        <template slot="option" slot-scope="props">
          <div class="option__desc">
            <span class="option__title"
              >{{ props.option.code }} {{ props.option.name }}</span
            >
          </div>
        </template>
      </multiselect>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      baseUrl: "/api/oms/v1/setting-user/territory-master",
      options: [],
      selected: null,
    };
  },
  methods: {
    getData() {
      this.$vs.loading();
      this.$http
        .get(this.baseUrl, {
          params: {
            order: "code",
            sort: "asc",
            type: "Sales",
          },
        })
        .then((resp) => {
          if (resp.status == "success") {
            var myUserRoles = this.$store.state.user.currentUser.roles;
            // if myUserRoles is has "admin" role, then show all territory
            var showAll = myUserRoles.some(function (el) {
              return el == "admin";
            });
            var options = [];

            if (showAll) {
              options.push({
                id: 0,
                // name: "All",
                code: "All",
              });
            }
            this.selected = options[0];
            resp.data.records.forEach(function (item) {
              options.push(item);
            }, options);
            this.options = options;
            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
            console.log(resp.data);
          }
        });
    },
  },
  watch: {
    selected(v) {
      this.selected = v;
      if (v) {
        this.$emit("data", v.id, v.code);
      } else {
        // this.$emit("data", v.id, v.code);
      }
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
